import { render, staticRenderFns } from "./reddit.vue?vue&type=template&id=74d6847a&"
import script from "./reddit.vue?vue&type=script&lang=ts&"
export * from "./reddit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports